export enum EnumTipoLead {
  Estandar = 1,
  Personalizado,
  Precios
}
